import { Dispatch, RootState, makeActionCreator } from "../../store/types";
import { history } from "../../store";
import { Product, Category } from "../../models";
import { selectors as searchSelectors } from "../ProductSearch";
import * as wizardActions from "../Wizard/actions";

export const SET_CATEGORIES = "step1/SET_CATEGORIES";
export const SET_CATEGORIES_LOADING = "step1/SET_CATEGORIES_LOADING";
export const SET_CHOSEN_PRODUCT = "step1/SET_CHOSEN_PRODUCT";
export const SET_CHOSEN_CATEGORY = "step1/SET_CHOSEN_CATEGORY";
export const RESET = "step1/RESET";

const setCategories = makeActionCreator<
  Category[]
>(SET_CATEGORIES as typeof SET_CATEGORIES);
const setCategoriesLoading = makeActionCreator<
  boolean
>(SET_CATEGORIES_LOADING as typeof SET_CATEGORIES_LOADING);
export const setChosenProduct = makeActionCreator<
  Product | undefined
>(SET_CHOSEN_PRODUCT as typeof SET_CHOSEN_PRODUCT);
export const setChosenCategory = makeActionCreator<
  Category
>(SET_CHOSEN_CATEGORY as typeof SET_CHOSEN_CATEGORY);
export const reset = makeActionCreator(RESET as typeof RESET);

// TODO: probably unused after changes being made to prev button login
export const cancelProduct = () => (
  dispatch: Dispatch,
  getState: () => RootState,
) => {
  const searchValue = searchSelectors.searchValue(getState());

  // Either go back to step 1-1 if no search input, else go back to step 1-2 results view
  const nextPath = !searchValue ? "/wizard/step-1" : "/wizard/step-1/products";
  history.replace(nextPath);
  dispatch(setChosenProduct(undefined));
  dispatch(wizardActions.resetProductChoices());
};

export const chooseProduct = (p?: Product) => (dispatch: Dispatch) => {
  dispatch(setChosenProduct(p));
  dispatch(wizardActions.resetProductChoices());
};

export const chooseProductById = (id: string | number) => async (
  dispatch: Dispatch,
  _,
  http,
) => {
  try {
    const { product } = await http.get(`data/products/${id}`);
    dispatch(setChosenProduct(product));
  } catch (error) {
    throw error;
  }
};

// TODO: proper stateful error handling
export const fetchCategories = () => async (dispatch: Dispatch, _, http) => {
  dispatch(setCategoriesLoading(true));

  try {
    // TODO: possible future pagination needed (endpoint just affords opt. limit)
    const result: any = await http.get("data/categories");

    dispatch(setCategories(result.categories || []));
  } catch (error) {
    throw error;
  } finally {
    dispatch(setCategoriesLoading(false));
  }
};



// WEBPACK FOOTER //
// ./src/routes/Step1/actions.ts